/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Tabs } from '@teamsnap/snap-ui';
import { ReportType } from 'components/pages/financials';
import { ROUTES } from 'core/routes';
import { useFinancials } from 'hooks/financials';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { generatePath } from 'react-router';
import { useHistory } from 'react-router-dom';
import FinancialsDepositList from './deposit/deposit-list';
import FinancialsOutstandingList from './outstanding/outstanding-list';
import FinancialsTransactionsList from './transaction/transaction-list';

export interface Props {
  currentReport?: ReportType;
  setCurrentReport: (reportType: ReportType) => void;
}
const FinancialsTabs = ({ currentReport, setCurrentReport }: Props) => {
  const [tabs, setTabs] = useState<Tab[]>([]);
  const history = useHistory();
  const { hasOrgAdminAccess, organization, transactionFilters } =
    useFinancials();

  useEffect(() => {
    if (hasOrgAdminAccess === null || !organization) {
      return;
    }
    const tabKeys = [
      ReportType.Deposits,
      ReportType.Outstanding,
      ReportType.Transactions,
    ];
    setTabs(
      tabKeys
        .splice(hasOrgAdminAccess ? 0 : 1)
        .map((reportType) => getFinancialsTab(reportType))
    );
  }, [hasOrgAdminAccess, transactionFilters, organization]);

  const onTabChange = (value: string) => {
    setCurrentReport(value as ReportType);
    history.replace(
      generatePath<string>(ROUTES.FINANCIALS, {
        orgId: organization.id,
        reportType: value,
      })
    );
  };

  const getFinancialsTab = useCallback(
    (reportType: ReportType): Tab => {
      if (!organization) {
        return {
          label: null,
          content: null,
          value: '',
        };
      }
      switch (reportType) {
        case ReportType.Deposits:
          return {
            label: 'Deposits',
            value: ReportType.Deposits,
            content: (
              <div className="sui-mt-2">
                <FinancialsDepositList setCurrentReport={setCurrentReport} />
              </div>
            ),
          };
        case ReportType.Transactions:
          return {
            label: 'Transactions',
            value: ReportType.Transactions,
            content: (
              <div className="sui-mt-2">
                <FinancialsTransactionsList />
              </div>
            ),
          };
        case ReportType.Outstanding:
        default:
          return {
            label: 'Outstanding',
            value: ReportType.Outstanding,
            content: (
              <div className="sui-mt-2">
                <FinancialsOutstandingList />
              </div>
            ),
          };
      }
    },
    [organization, history, transactionFilters]
  );

  if (
    !tabs.length ||
    hasOrgAdminAccess === undefined ||
    organization === undefined
  ) {
    return null;
  }

  return (
    <Tabs
      defaultValue={ReportType.Outstanding}
      onChange={onTabChange}
      value={currentReport}
      tabs={tabs}
    />
  );
};

type Tab = {
  label: string;
  content: React.ReactNode;
  value: string;
};

export default FinancialsTabs;
